module.exports = __webpack_public_path__ + "736dffa00cb8526472eac1034d686615.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/pages/notFound/ic_binoculars.svg
// module id = Qq8P
// module chunks = 5